import { ContactUs, CopyrightFooter } from 'app/components';
import { Container, IAppState } from 'app/containers/Container';
import * as React from 'react';
import { Col, Row, Tab, Nav, NavItem, Image, Panel } from 'react-bootstrap';
import { GivIndex } from 'app/components/visualizations/GivIndex';
import { AssetsAndGrants } from 'app/components/visualizations/AssetsAndGrants';
import { TopFoundations } from 'app/components/visualizations/TopFoundations';
import { AssetClassReturns } from 'app/components/visualizations/AssetClassReturns';
import { DataAsOf } from 'app/components/visualizations/DataAsOf';
import { AssetAndGrantsTable } from 'app/components/visualizations/AssetAndGrantsTable';
import { GivIndexTable } from 'app/components/visualizations/GivIndexTable';
import { FoundationMarkIndexLine } from 'app/components/visualizations/FoundationMarkIndex/Line';
import { AdditionalIndicesChart } from 'app/components/visualizations/AdditionalIndicesChart';
import { AdditionalIndicesTable } from 'app/components/visualizations/AdditionalIndicesTable';
import { FoundationMarkIndexTable } from 'app/components/visualizations/FoundationMarkIndex/Table';

interface IHomeState {
  isLoggedIn: boolean;
  apiKey: string;
  username: string;
  state?: string;
  stateLabel?: string;
  activeKey?: string;
}

class Home extends Container<{}, IHomeState> {
  state: IHomeState = {
    isLoggedIn: false,
    apiKey: null,
    username: null,
    state: '',
    stateLabel: '',
    activeKey: 'first',
  };

  mapAppStateToContainerState(appState: IAppState) {
    const isLoggedIn = !!appState.User.username;
    const username = appState.User.username;
    const key = appState.User.token;
    return { isLoggedIn, username, apiKey: key };
  }

  onFilterChange(filters) {
    this.setState({ state: filters.state, stateLabel: filters.stateLabel });
  }

  handleSelect(activeKey: any) {
    this.setState({ activeKey });
  }

  render() {
    const { state, stateLabel, activeKey } = this.state;
    const stateOption = { id: state, stateLabel };
    const newYorkOption = { id: 'NY', stateLabel: 'New York' };

    return (
      <section>
        <section className="container margin-bottom" style={{ overflowX: 'hidden' }}>
          <section className="animated fadeIn">
            <section className="margin-y-lg text-center">
              <section
                style={{
                  backgroundColor: '#f2f2f2',
                  padding: '28px 24px',
                  marginBottom: '24px',
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    color: '#7a7a7a',
                    fontWeight: 400,
                    lineHeight: '1.45',
                    fontSize: '3.2rem',
                  }}
                >
                  FoundationMark is the Leading Source of Foundation Financial Information Including Investment Performance, Peer Group Reports,
                  and Market Intelligence
                </h2>
              </section>
              <Row style={{ marginLeft: '-10px', marginRight: '-10px' }}>
                <Col sm={4} xs={12} style={{ paddingLeft: '10px', paddingRight: '10px', marginBottom: '15px' }}>
                  <a
                    href="/#/indices"
                    style={{
                      width: '100%',
                      minHeight: '110px',
                      backgroundColor: '#1f6f98',
                      borderColor: '#123b57',
                      borderWidth: '3px',
                      borderRadius: '14px',
                      color: '#fff',
                      fontSize: '2.3rem',
                      lineHeight: '1.2',
                      padding: '18px 12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      whiteSpace: 'normal',
                      textDecoration: 'none',
                    }}
                  >
                    Investment
                    <br />
                    Performance
                  </a>
                </Col>
                <Col sm={4} xs={12} style={{ paddingLeft: '10px', paddingRight: '10px', marginBottom: '15px' }}>
                  <a
                    href="/#/peergroup"
                    style={{
                      width: '100%',
                      minHeight: '110px',
                      backgroundColor: '#1f6f98',
                      borderColor: '#123b57',
                      borderWidth: '3px',
                      borderRadius: '14px',
                      color: '#fff',
                      fontSize: '2.3rem',
                      lineHeight: '1.2',
                      padding: '18px 12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      whiteSpace: 'normal',
                      textDecoration: 'none',
                    }}
                  >
                    Peer Groups
                  </a>
                </Col>
                <Col sm={4} xs={12} style={{ paddingLeft: '10px', paddingRight: '10px', marginBottom: '15px' }}>
                  <a
                    href="/#/market-intelligence"
                    style={{
                      width: '100%',
                      minHeight: '110px',
                      backgroundColor: '#1f6f98',
                      borderColor: '#123b57',
                      borderWidth: '3px',
                      borderRadius: '14px',
                      color: '#fff',
                      fontSize: '2.3rem',
                      lineHeight: '1.2',
                      padding: '18px 12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      whiteSpace: 'normal',
                      textDecoration: 'none',
                    }}
                  >
                    Market
                    <br />
                    Intelligence
                  </a>
                </Col>
              </Row>
            </section>
            <section className="margin-y-lg" /*style={{ border: '1px solid grey', padding: '10px' }}*/>
              <Tab.Container id="left-tabs-example" activeKey={activeKey} onSelect={(activKey) => this.handleSelect(activKey)}>
                <Row className="clearfix">
                  <Col sm={3}>
                    <div className="panel panel-default">
                      <div className="panel-heading" style={{ backgroundColor: '#072E4F', color: 'white', fontSize: '2.0rem' }}>
                        Performance
                      </div>
                      <div id="collapse1" className="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                        <div className="panel-body">
                          <Nav bsStyle="pills" stacked>
                            <NavItem eventKey="first" className="homeTabs">
                              GIV Index
                            </NavItem>
                            <NavItem eventKey="fm" className="homeTabs">
                              FoundationMark Indices
                            </NavItem>
                            <NavItem eventKey="addtl" className="homeTabs">
                              Additional GIV Indices
                            </NavItem>
                            <NavItem eventKey="sixth" className="homeTabs">
                              Asset Class Returns
                            </NavItem>
                          </Nav>
                        </div>
                      </div>
                    </div>
                    <div className="panel panel-default">
                      <div className="panel-heading" style={{ backgroundColor: '#072E4F', color: 'white', fontSize: '2.0rem' }}>
                        Assets and Grantmaking
                      </div>
                      <div className="panel-body">
                        <Nav bsStyle="pills" stacked>
                          <NavItem eventKey="second" className="homeTabs">
                            Asset Trends
                          </NavItem>
                          <NavItem eventKey="grant" className="homeTabs">
                            Grantmaking Trends
                          </NavItem>
                          <NavItem eventKey="state" className="homeTabs">
                            State Trends
                          </NavItem>
                        </Nav>
                      </div>
                    </div>
                    <div className="panel panel-default">
                      <div className="panel-heading" style={{ backgroundColor: '#072E4F', color: 'white', fontSize: '2.0rem' }}>
                        Comparative Analysis
                      </div>
                      <div className="panel-body">
                        <Nav bsStyle="pills" stacked>
                          <NavItem eventKey="third" className="homeTabs">
                            The FoundationMark15
                          </NavItem>
                          <NavItem eventKey="fifth" className="homeTabs">
                            Individual Peformance Reports
                          </NavItem>
                          <NavItem className="homeTabs" href={'#/peergroup'}>
                            Peer Groups
                          </NavItem>
                        </Nav>
                      </div>
                    </div>
                  </Col>
                  <Col sm={9}>
                    <Tab.Content animation>
                      <Tab.Pane
                        eventKey="fm"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'fm' && (
                          <>
                            <header className="homeHeader">FoundationMark Indices</header>
                            <FoundationMarkIndexLine displayClickHere />
                            <Panel style={{ marginTop: '10px' }}>
                              <FoundationMarkIndexTable />
                            </Panel>
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="first"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'first' && (
                          <>
                            <header className="homeHeader">Foundation Performance Indices</header>
                            <DataAsOf />
                            <GivIndex chartHeight={50} titleFontSize="1.5rem" displayClickHere />
                            <GivIndexTable />
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="addtl"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'addtl' && (
                          <>
                            <header className="homeHeader">Additional GIV Indices</header>
                            <AdditionalIndicesChart alwaysEnabled barclayEnabled sfEnabled spEnabled displayClickHere />
                            <AdditionalIndicesTable alwaysEnabled barclayEnabled sfEnabled spEnabled />
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="second"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'second' && (
                          <>
                            <header className="homeHeader">Assets Trends</header>
                            <DataAsOf />
                            <AssetsAndGrants displayAssets displayClickHere onChange={this.onFilterChange.bind(this)} />
                            <AssetAndGrantsTable state={stateOption} stateLabel={stateLabel} />
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="grant"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'grant' && (
                          <>
                            <header className="homeHeader">Grantmaking Trends</header>
                            <DataAsOf />
                            <AssetsAndGrants displayGrants displayClickHere onChange={this.onFilterChange.bind(this)} />
                            <AssetAndGrantsTable />
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="state"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'state' && (
                          <>
                            <header className="homeHeader">State Trends</header>
                            <DataAsOf />
                            <AssetsAndGrants displayGrants displayAssets state="NY" stateLabel="New York" displayClickHere />
                            <AssetAndGrantsTable state={newYorkOption} stateLabel="New York" />
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="third"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'third' && (
                          <>
                            <header className="homeHeader">FoundationMark 15</header>
                            <TopFoundations displayClickHere />
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="fourth"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'fourth' && (
                          <>
                            <header className="homeHeader">Star Ratings: What are they?</header>
                            <TopFoundations />
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="fifth"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'fifth' && (
                          <>
                            <header className="homeHeader">FoundationMark Performance Reports</header>
                            <p style={{ textAlign: 'center', color: '#333', padding: '10px' }}>
                              FoundationMark provides trustees with comparative financial reports on their foundation.
                            </p>
                            <header style={{ textAlign: 'center', fontSize: '1.8rem', color: 'rgb(0, 176, 80)' }}>
                              <span style={{ textAlign: 'center', fontSize: '1.8rem', color: 'rgb(0, 176, 80)' }}>
                                Click <a style={{ color: '#333' }}>here</a> to request yours.
                              </span>
                            </header>
                            <a href="/#/reports" style={{ padding: '10px' }}>
                              <Image src="/assets/img/FoundationMarkPerformanceReportOct15.png" rounded responsive />
                            </a>
                          </>
                        )}
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="sixth"
                        style={{ border: '1px solid #1f5b8f', borderRadius: '3px', padding: '5px', minHeight: '605px' }}
                      >
                        {activeKey === 'sixth' && (
                          <>
                            <header className="homeHeader">Investment Performance by Asset Class</header>
                            <DataAsOf />
                            <AssetClassReturns displayClickHere />
                          </>
                        )}
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </section>

            <footer className="margin-y-xl">
              <ContactUs />
              <CopyrightFooter />
            </footer>
          </section>
        </section>
      </section>
    );
  }
}

export { Home };



// WEBPACK FOOTER //
// ./src/app/containers/Home/index.tsx